

export class ContractModalModel {
  /**
   * 담당자명
   *
   *
   */
  readonly pernm: string

  /**
   * 현장명
   *
   *
   */
  readonly actnm: string

  /**
   * 계역구분
   *
   *
   */
  readonly contgubun: string

  /**
   * 만료일
   *
   *
   */
  readonly enddate: string

  /**
   * 계약분류
   *
   *
   */
  readonly contg: string

  /**
   * 상태
   *
   *
   */
  readonly state: string

  /**
   * 최근계약기록내역
   *
   */
  readonly title: string;

  /**
   * 최근기록일
   *
   */
  readonly hdate: string;

  /**
   * 최근계약작성자
   *
   */
  readonly hispernm: string;

  constructor(data: any = {}) {
    this.pernm = data.pernm || '';
    this.actnm = data.actnm || '';
    this.contgubun = data.contgubun || '';
    this.enddate = data.enddate || '';
    this.contg = data.contg || '';
    this.state = data.state || '';
    this.title = data.title || '';
    this.hdate = data.hdate || '';
    this.hispernm = data.hispernm || '';
  }
}
